import { createFileRoute, Link, Outlet } from '@tanstack/react-router';
import { Mail, FileText, Workflow, ShieldAlert, Building2 } from 'lucide-react';
import { currentUser } from '~/lib/pb';
import { useTenantContext } from '~/lib/tenantContext';
import styles from './_authed.automations.module.css';

// Layout del módulo de Automatizaciones (superadmin-only).
// Estilo Focus simplificado (skill focus-ui-density): solo título + sub-nav.
//
// Contiene el selector de cliente global del módulo: las 3 rutas hijas
// (templates, forms, flows) filtran por el `selectedTenantId` del contexto.
// El mismo selector se comparte con CRM/Dashboard/Reports — cambiar cliente
// acá también lo cambia ahí.

export const Route = createFileRoute('/_authed/automations')({
  component: AutomationsLayout,
});

function AutomationsLayout() {
  const me = currentUser();
  const isSuperadmin = me?.role === 'superadmin';
  const { tenants, selectedTenantId, setSelectedTenantId } = useTenantContext();

  if (!isSuperadmin) {
    return (
      <div className={styles.page}>
        <div className={styles.notSuperadmin}>
          <ShieldAlert size={32} aria-hidden style={{ marginBottom: 12 }} />
          <p>El módulo de Automatizaciones es solo para superadmins.</p>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.page}>
      <header className={styles.header}>
        <div className={styles.headerRow}>
          <h1 className="h2" style={{ margin: 0 }}>Automatizaciones</h1>
          <label className={styles.tenantPicker} title="Cliente activo">
            <Building2 size={14} aria-hidden />
            <span className={styles.tenantPicker__label}>Operando sobre:</span>
            <select
              className={styles.tenantPicker__select}
              value={selectedTenantId ?? ''}
              onChange={(e) => setSelectedTenantId(e.target.value)}
              aria-label="Cliente activo"
            >
              {tenants.map((t) => (
                <option key={t.id} value={t.id}>
                  {t.name}
                </option>
              ))}
            </select>
          </label>
        </div>
        <p className={styles.headerHint}>
          Plantillas, formularios y flujos del cliente activo. Las plantillas
          globales del sistema se ven en cualquier cliente.
        </p>
      </header>

      <nav className={styles.subnav} aria-label="Secciones de Automatizaciones">
        <Link
          to="/automations/templates"
          className={styles.subnavLink}
          activeProps={{
            className: `${styles.subnavLink} ${styles['subnavLink--active']}`,
          }}
        >
          <Mail size={14} aria-hidden /> Plantillas email
        </Link>
        <Link
          to="/automations/forms"
          className={styles.subnavLink}
          activeProps={{
            className: `${styles.subnavLink} ${styles['subnavLink--active']}`,
          }}
        >
          <FileText size={14} aria-hidden /> Formularios
        </Link>
        <Link
          to="/automations/flows"
          className={styles.subnavLink}
          activeProps={{
            className: `${styles.subnavLink} ${styles['subnavLink--active']}`,
          }}
        >
          <Workflow size={14} aria-hidden /> Flujos
        </Link>
      </nav>

      <Outlet />
    </div>
  );
}
